const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  body: {
    padding: theme.spacing(2.5),
    flex: 1,
    overflowY: 'auto',
    maxHeight: '100%',
  },
  footer: {
    padding: theme.spacing(2.5),
  },
  textarea: {
    marginTop: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  giftOption: {
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  giftOptionTerm: {
    fontSize: 14,
    letterSpacing: 0.14,
    color: theme.color.grey_8A,
    display: 'block',
  },
  checkbox: {
    marginLeft: theme.spacing(-1),
  },
});

export default styles;
